var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveCombinedShape({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 19,
    viewBox: "0 0 5 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75391 2.06445C4.75391 3.16902 3.85848 4.06445 2.75391 4.06445C1.64934 4.06445 0.753906 3.16902 0.753906 2.06445C0.753906 0.959884 1.64934 0.0644531 2.75391 0.0644531C3.85848 0.0644531 4.75391 0.959884 4.75391 2.06445ZM4.75391 9.35445C4.75391 10.459 3.85848 11.3545 2.75391 11.3545C1.64934 11.3545 0.753906 10.459 0.753906 9.35445C0.753906 8.24988 1.64934 7.35445 2.75391 7.35445C3.85848 7.35445 4.75391 8.24988 4.75391 9.35445ZM2.75391 18.6445C3.85848 18.6445 4.75391 17.749 4.75391 16.6445C4.75391 15.5399 3.85848 14.6445 2.75391 14.6445C1.64934 14.6445 0.753906 15.5399 0.753906 16.6445C0.753906 17.749 1.64934 18.6445 2.75391 18.6445Z",
    fill: "#DFB322"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCombinedShape);
export default __webpack_public_path__ + "static/media/active-CombinedShape.2b12e200591e83c7a9a8203049eaba87.svg";
export { ForwardRef as ReactComponent };